import { Button, InputField } from "../../../components/forms";
import { GoDotFill, GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { Fragment, ReactNode, useEffect, useState } from "react";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import EmployeeDetailed from "./EmployeeDetailed";
import useLeaveHook from "../../../hooks/useLeaveHook";
import { BsCalendar, BsGrid, BsPersonFillDash } from "react-icons/bs";
import { TbDashboard } from "react-icons/tb";
import useGoalsHook from "../../../hooks/useGoalsHook";
import Goallisting from "./Goallisting";
import { AddGoalmodal } from "../../../components/Modules/Employees/AddGoalModal";
import { Menu, Transition } from "@headlessui/react";

const Goals = () => {
  const statusPicked = usePickerhook();
  const positionPicked = usePickerhook();
  const [showadddGoal, setshowadddGoal] = useState(false);
  const { selectedOrgEmployees, refresh } = useEmployeeHook();
  const [renderedlist, setrenderedlist] = useState(selectedOrgEmployees);
  const { OrgLeaveReq, setOrgLeaveReq } = useLeaveHook();
  const [target, setTarget] = useState("");
  const { allorgoals, AddGoal, getOrgGoals } = useGoalsHook();
  const tabs = [
    { icon: <BsGrid className=" inline mr-1" />, title: "Grid" },
    { icon: <BsCalendar className=" inline  mr-1 " />, title: "Calender" },
    { icon: <TbDashboard className=" inline  mr-1" />, title: "Dashboard" },
  ];

  const tabViews = [
    <Goallisting
      refresh={getOrgGoals}
      goals={allorgoals}
      isAdminview={true}
      setshowaddleavemodal={() => {}}
    />,
    <></>,
    <></>,
  ];
  const [selectedTabview, setselectedTabview] = useState<JSX.Element>(
    tabViews[0]
  );
  const ActionItem2 = ({ title, icon, key_ }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[key_]);
        setselectedTab(title);
      }}
      className={`m-1 rounded-[8px]    p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs flex justify-center items-center ">
        {icon}
        {title}
      </p>
    </div>
  );
  const [selectedTab, setselectedTab] = useState(tabs[0].title);
  const { authuser } = useStateGetter();
  const { setselectedEmpl, setSidebarRenderView, setShowModal } =
    useStateSetter();
  const [entered, setentered] = useState("");
  const onChange = (e: string) => {
    setentered(e);
  };

  useEffect(() => {
    setrenderedlist(
      OrgLeaveReq.filter((t) => statusPicked.pickedRole.code.includes(t.status))
    );
  }, [statusPicked.pickedRole]);
  useEffect(() => {
    setrenderedlist(
      selectedOrgEmployees.filter(
        (t) => t.positionID == positionPicked.pickedRole.code
      )
    );
  }, [positionPicked.pickedRole]);
  useEffect(() => {
    if (authuser.isEmployee) {
      selectedOrgEmployees.map((it: any) => {
        if (it.workEmail == authuser.email) {
          setselectedEmpl(it);
          setSidebarRenderView(<EmployeeDetailed id={it.id} />);
        }
      });
    }
  }, [selectedOrgEmployees]);
  return (
    <div className="w-full pr-20  flex  ">
      {showadddGoal && (
        <AddGoalmodal
          target={target}
          refresh={getOrgGoals}
          show={setshowadddGoal}
        />
      )}
      <div className={` p-6 bg-white  h-[100vh]  w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between  gap-4 items-center  ">
          <div>
            <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
              Goals ({allorgoals.length})
            </p>
            <div className="flex gap-2  ">
              <div className="border border-gray-300 p-1 flex rounded-md  ">
                {tabs.map((it, key) => (
                  <ActionItem2 key_={key} {...it} />
                ))}
              </div>

              <ListPicker
                hook={statusPicked}
                notitle
                title="All status"
                list={[
                  { code: "pending", name: "Pending" },
                  { code: "approved", name: "Approved" },
                  { code: "cancelled", name: "Cancelled" },
                  { code: "rejected", name: "Rejected" },
                ]}
              />
            </div>
          </div>

          <Menu as="div" className={`relative my-2 `}>
            <Menu.Button className="   w-full  ">
              <Button
                width={200}
                disabled={false}
                text={
                  <>
                    <GoPlus size={15} className=" mx-1 inline" />
                    Add goal
                  </>
                }
                onBtnClick={() => {}}
              />
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                onClick={() => {
                  setshowadddGoal(true);
                }}
                className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[250px] min-w-[180px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
              >
                <Menu.Item>
                  <p
                    onClick={() => {
                      setTarget("empl");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Employee
                  </p>
                </Menu.Item>
                <Menu.Item>
                  <p
                    onClick={() => {
                      setTarget("org");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Organization
                  </p>
                </Menu.Item>
                <Menu.Item>
                  <p
                    onClick={() => {
                      setTarget("dept");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Department
                  </p>
                </Menu.Item>

                <Menu.Item>
                  <p
                    onClick={async () => {
                      setTarget("pos");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Position
                  </p>
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

        <Goallisting
          refresh={getOrgGoals}
          goals={allorgoals}
          isAdminview={true}
          setshowaddleavemodal={() => {}}
        />
      </div>
    </div>
  );
};
export { Goals };

const todatestring = (datestring: string) => {
  var date = new Date(datestring);
  return date.toDateString();
};
